import { ArrowHelper, Group, Scene, Vector3 } from 'three';
import { Vertex } from '@thirdPartyLibraries/three-mesh-halfedge/src';
import { threeStore } from '@modules/three/store/threeStore.ts';
import { threeInteractionStore } from '@modules/three/store/threeInteractionStore.ts';
import { createAnchorMarker, disposeObject3D } from '@modules/three/common/visual/segmentationVisuals';

export interface MeshAnchor {
  position: Vector3;
  marker: Group;
  arrow: ArrowHelper;
  intersectVertex: Vertex;
  cameraPosition: Vector3;
}

export default class MeshAnchorCollection extends Array<MeshAnchor> {
  private scene: Scene;

  constructor() {
    super();
    this.scene = threeStore.getState().rootState.scene;
  }

  /**
   * Adds an anchor to a scene
   *
   * @param position The position of the point
   * @param intersectVertex The intersectVertex the point intersects
   * @param cameraPosition The position of the camera
   */

  public addAnchor = (position: Vector3, intersectVertex: Vertex, cameraPosition: Vector3) => {
    const { marker, arrow } = createAnchorMarker(position, cameraPosition);
    this.scene.add(marker);
    this.scene.add(arrow);
    this.push({ position, marker, intersectVertex, cameraPosition, arrow });
    try {
      threeInteractionStore.getState().bumpAnchorTick();
    } catch {
      /* store may be unavailable in tests */
    }
  };

  public removeLast = () => {
    if (this.length === 0) {
      return;
    }
    const anchor = this[this.length - 1];
    disposeObject3D(anchor.marker);
    anchor.arrow.dispose();
    this.scene.remove(anchor.marker);
    this.scene.remove(anchor.arrow);
    this.pop();
    try {
      threeInteractionStore.getState().bumpAnchorTick();
    } catch {
      /* store may be unavailable in tests */
    }
  };

  public removeAll = () => {
    const length = this.length;
    for (let i = 0; i < length; i++) {
      this.removeLast();
    }
  };

  /** Hide insertion arrows once tooth contours are confirmed. */
  public setArrowsVisible = (visible: boolean) => {
    for (const anchor of this) {
      anchor.arrow.visible = visible;
    }
  };
}
